export const apipath = process.env.NODE_ENV == 'development' ? 'http://localhost:9999/api' : '/api'



/* let file = async function(name, req, image){  
  if (!req) req = {}
  console.log('req', {name, req})
  req = JSON.stringify({name, req})  
  const request = new Request(apipath, {
    headers: {"Content-Type": "application/json"},
    method: "POST",
    body: req,
  });

  try {
    const response = await fetch(request)
    let result = await response.blob()
    if (image) {
      const objectURL = URL.createObjectURL(result);
      return objectURL;
    }
    return result 
  } catch (error) {
    console.error(error);
    console.log(error);
    return {error:{id:'try',code:500, error: error}}
  }
} */

let upload = async function(path, file, name){
  console.log('upload', path, file.length )
  return new Promise(function (resolve, reject) {
    const rs = new XMLHttpRequest();
    let host = `${apipath}${path}?name=${name}`;    
    rs.open('post', host, true);
    rs.onload = function () {
      if (rs.status != 200)
        reject({ error: { id: 'try' } });
      if (!rs.response) resolve({});
      const resp = JSON.parse(rs.response);
      resolve(resp);
    };
    const uint8 = new Uint8Array(file);
    rs.send(uint8);
  });
}

// upload avatar
let avatar    = async function(file)      {return upload(`/upload/avatar`, file)}
let image     = async function(file)      {return upload(`/upload/image`, file)}
let chat      = async function(file,name) {return upload(`/upload/chat`, file, name)}
let storage   = async function(file,name) {return upload(`/upload/storage`, file,name)}
let exchange  = async function(file,name) {return upload(`/upload/exchange`, file,name)}

export default {
  avatar, image, chat, storage, exchange
}